import { TransitionReportContract } from '../contracts/transition-report.contract';

export class TransitionReport {
  public constructor(
    public id: number,
    public first_name: string,
    public last_name: string,
    public birth_date: string,
    public street_and_house_number: string,
    public city: string,
    public district: string,
    public postal_code: string,
    public country: string,
    public interests: string,
    public comp_learning_describes_success: boolean,
    public comp_learning_seeks_help: boolean,
    public comp_learning_persists: boolean,
    public comp_communication_expresses_clearly: boolean,
    public comp_communication_listens: boolean,
    public comp_communication_uses_language: boolean,
    public comp_social_knows_strengths: boolean,
    public comp_social_cooperates: boolean,
    public comp_social_resolves_conflicts: boolean,
    public comp_citizenship_reflects: boolean,
    public comp_citizenship_creates_rules: boolean,
    public comp_citizenship_empathy: boolean,
    public comp_work_plans: boolean,
    public comp_work_completes: boolean,
    public comp_work_follows_rules: boolean,
    public comp_problem_solving_proposes: boolean,
    public comp_problem_solving_describes: boolean,
    public comp_problem_solving_seeks_alternatives: boolean,
    public comp_cultural_participates: boolean,
    public comp_cultural_understands_values: boolean,
    public comp_cultural_respects_diversity: boolean,
    public comp_digital_uses_tools: boolean,
    public comp_digital_understands_purpose: boolean,
    public comp_digital_follows_rules: boolean,
    public additional_strengths: string,
    public method_text: string,
    public method_speaking_listening: boolean,
    public method_demonstration: boolean,
    public method_manipulation: boolean,
    public method_role_play: boolean,
    public method_learning_by_rules: boolean,
    public method_creative_learning: boolean,
    public method_reflection: boolean,
    public method_group_learning: boolean,
    public method_digital_support: boolean,
    public org_form_collective: boolean,
    public org_form_group: boolean,
    public org_form_activity_centers: boolean,
    public org_form_individual: boolean,
    public org_form_free_play: boolean,
    public org_form_outdoor: boolean,
    public org_form_circle_time: boolean,
    public org_form_routine: boolean,
    public org_form_project: boolean,
    public family_cooperation: string,
    public socioemotional_support_needed: boolean,
    public socioemotional_notes: string,
    public language_support_needed: boolean,
    public language_notes: string,
    public gross_motor_support_needed: boolean,
    public gross_motor_level: string,
    public gross_motor_diagnostic_date: string,
    public gross_motor_notes: string,
    public fine_motor_support_needed: boolean,
    public fine_motor_level: string,
    public fine_motor_diagnostic_date: string,
    public fine_motor_notes: string,
    public visual_perception_support_needed: boolean,
    public visual_perception_level: string,
    public visual_perception_diagnostic_date: string,
    public visual_perception_notes: string,
    public auditory_perception_support_needed: boolean,
    public auditory_perception_level: string,
    public auditory_perception_diagnostic_date: string,
    public auditory_perception_notes: string,
    public support_measures_recommended: boolean,
    public created: string,
    public modified: string
  ) {}

  /**
   * Deserialize JSON to typescript object.
   *
   * @param data
   */
  public static deserialize(data: TransitionReportContract): TransitionReport {
    const report = new TransitionReport(
      data.id,
      data.first_name,
      data.last_name,
      data.birth_date,
      data.street_and_house_number,
      data.city,
      data.district,
      data.postal_code,
      data.country,
      data.interests,
      data.comp_learning_describes_success,
      data.comp_learning_seeks_help,
      data.comp_learning_persists,
      data.comp_communication_expresses_clearly,
      data.comp_communication_listens,
      data.comp_communication_uses_language,
      data.comp_social_knows_strengths,
      data.comp_social_cooperates,
      data.comp_social_resolves_conflicts,
      data.comp_citizenship_reflects,
      data.comp_citizenship_creates_rules,
      data.comp_citizenship_empathy,
      data.comp_work_plans,
      data.comp_work_completes,
      data.comp_work_follows_rules,
      data.comp_problem_solving_proposes,
      data.comp_problem_solving_describes,
      data.comp_problem_solving_seeks_alternatives,
      data.comp_cultural_participates,
      data.comp_cultural_understands_values,
      data.comp_cultural_respects_diversity,
      data.comp_digital_uses_tools,
      data.comp_digital_understands_purpose,
      data.comp_digital_follows_rules,
      data.additional_strengths,
      data.method_text,
      data.method_speaking_listening,
      data.method_demonstration,
      data.method_manipulation,
      data.method_role_play,
      data.method_learning_by_rules,
      data.method_creative_learning,
      data.method_reflection,
      data.method_group_learning,
      data.method_digital_support,
      data.org_form_collective,
      data.org_form_group,
      data.org_form_activity_centers,
      data.org_form_individual,
      data.org_form_free_play,
      data.org_form_outdoor,
      data.org_form_circle_time,
      data.org_form_routine,
      data.org_form_project,
      data.family_cooperation,
      data.socioemotional_support_needed,
      data.socioemotional_notes,
      data.language_support_needed,
      data.language_notes,
      data.gross_motor_support_needed,
      data.gross_motor_level,
      data.gross_motor_diagnostic_date,
      data.gross_motor_notes,
      data.fine_motor_support_needed,
      data.fine_motor_level,
      data.fine_motor_diagnostic_date,
      data.fine_motor_notes,
      data.visual_perception_support_needed,
      data.visual_perception_level,
      data.visual_perception_diagnostic_date,
      data.visual_perception_notes,
      data.auditory_perception_support_needed,
      data.auditory_perception_level,
      data.auditory_perception_diagnostic_date,
      data.auditory_perception_notes,
      data.support_measures_recommended,
      data.created,
      data.modified
    );

    return report;
  }
}
